export const AccountTypes = { // eslint-disable-line import/prefer-default-export
  INDIVIDUAL: {
    component: 'EditIndividualAccount',
    name: 'INDIVIDUAL',
    icon: 'img-profile-default',
    text: 'Individual Investor',
  },
  JOINT_ACCOUNT: {
    component: 'EditJointAccount',
    name: 'JOINT',
    icon: 'img-profile-joint',
    text: 'Joint Account',
  },
  UTMA_UGMA_ACCOUNT: {
    component: 'EditJointAccount',
    name: 'UTMA / UGMA',
    icon: 'img-profile-UGMA',
    text: 'UTMA/UGMA Account',
  },
  ADVISOR: {
    component: 'AccountDetail',
    name: 'ADVISOR',
    icon: 'img-profile-advisor',
    text: 'Financial Advisor',
  },
  ADMIN: {
    component: 'AccountDetail',
    name: 'ADMIN',
    icon: 'img-profile-default-admin',
    text: 'Admin',
  },
  INSTITUTION: {
    component: 'EditInstitutionAccount',
    name: 'INSTITUTION',
    icon: 'img-profile-institution',
    text: 'Institution Account',
  },
  TRUST: {
    component: 'EditTrustAccount',
    name: 'TRUST',
    icon: 'img-profile-trust',
    text: 'Trust Account',
  },
};



// WEBPACK FOOTER //
// ./src/data/static/accountTypes.js